<template>
  <sweet-modal ref="modal" width="40%" hide-close-button blocking>
      <section>
          <h1 class="mt-4">{{ $t('ct-not-found') }}</h1>
        </section>

      <button
        slot="button"
        class="btn btn-dark m-0"
        @click.prevent="goToHome"
      >{{ $t('ct-go-to-home')}}</button>
    </sweet-modal>
</template>

<script>

import { SweetModal } from 'sweet-modal-vue';
export default {
  name: 'NotFound',
  components: { SweetModal },

  methods: {
    goToHome() {
      this.$refs['modal'].close();
      this.$router.push({ name: 'Home' });
    }
  },

  mounted() {
    this.$refs['modal'].open();
  }
};
</script>

<style lang="scss" scoped>
 .sweet-buttons, .sweet-content-content{
    // font-family: Muli;
  }

  section{
    font-family: Muli;
    h1{
      font-weight: bold;
      font-size: 20px;
      color: #434343;
    }

    h2{
      color: #5A5959;
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/NotFound.vue